/**
 * Practice phone lines grouped as listed: consecutive entries of one facility
 * (or the practice itself, under "Practice") together. Shared by the comm
 * log's "Send from" and the call panel's "Call from".
 */
export function groupByFacility<T extends { facilityName: string | null }>(options: T[]) {
  const groups: { name: string; options: T[] }[] = [];
  for (const option of options) {
    const name = option.facilityName ?? "Practice";
    const last = groups[groups.length - 1];
    if (last && last.name === name) {
      last.options.push(option);
    } else {
      groups.push({ name, options: [option] });
    }
  }
  return groups;
}
